import { render, staticRenderFns } from "./DataAuth.vue?vue&type=template&id=80ccfa5c&scoped=true&"
import script from "./DataAuth.vue?vue&type=script&lang=js&"
export * from "./DataAuth.vue?vue&type=script&lang=js&"
import style0 from "./DataAuth.vue?vue&type=style&index=0&id=80ccfa5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ccfa5c",
  null
  
)

export default component.exports